import React, { useEffect, useState } from "react";
import { useTable } from "react-table";


const CashbackTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://prophel.in/get-products"); // Replace with actual API endpoint
        const result = await response.json();
        setData(result); // Assuming the API returns the list of objects directly
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Define table columns
  const columns = React.useMemo(
    () => [
      {
        Header: "Product ID",
        accessor: "productId",
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Phone",
        accessor: "userPhone",
      },
      {
        Header: "Claimed At",
        accessor: "claimedAt",
        Cell: ({ value }) => {
          // Format date
          const date = new Date(value);
          return date.toLocaleString();
        },
      },
      {
        Header: "Location",
        accessor: "location_lat",
        Cell: ({ row }) => {
          const lat = row.values.location_lat;
          const lon = row.values.location_lon;
          return (
            <span data-tip={`Latitude: ${lat}, Longitude: ${lon}`}>
              <i className="fas fa-map-marker-alt" style={{ color: "#FF5722" }}></i>
            </span>
          );
        },
      },
      {
        Header: "Cashback Amount",
        accessor: "cashbackAmount",
        Cell: ({ value }) => `Rs. ${parseFloat(value).toFixed(2)}`,
      },
      {
        Header: "Feedback",
        accessor: "feedback",
      },
    ],
    []
  );

  // Use react-table hooks
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });

  // Render Loading State
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="overflow-x-auto">
      <table {...getTableProps()} className="min-w-full table-auto bg-white shadow-lg rounded-lg">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} className="hover:bg-gray-100">
                {row.cells.map((cell) => (
                  <td
                    {...cell.getCellProps()}
                    className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CashbackTable;
